<ng-container *ngIf="!globalLoading">
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div class="col-auto col-md-12 col-xl-12 vh-100 p-0">
        <div class="col-inner p-0 p-xl-5 overflow-xl-hidden h-100">
          <div class="thankyou-inner rounded-xl-lg p-3 p-xl-5 bg-primary h-100">
            <div
              class="col-inner h-100 overflow-auto d-flex flex-column align-items-xl-start text-center text-xl-start">

              
                  <span class="fs-5">
                    <img src="{{getLogoPath()}}" alt="{{getApplicationName()}}" title="{{getApplicationName()}}"
                         class="logo"/>
                  </span>
              

              <div class="mt-3 mt-xxl-5 pt-0 pt-xxl-5 mb-4 text-white w-100">
                <div class="d-xl-flex flex-xl-row pt-5">

                  <div class="text-center text-xl-start mb-3 mb-xl-0">
                    <div class="check d-inline-block">
                      <img src="./assets/images/advofin_loading_finished_animation.svg?v={{svgId}}" alt="loading">
                    </div>
                  </div>

                  <div class="ps-xl-5 pt-2 w-100 fade-in-slow-400">
                    <h1 class="text-white fw-bold">{{'General.ConfirmationHeadline' | translate}}</h1>
                    <h3 class="text-white bg-warning px-2 py-1 d-inline-block mt-3 mt-xl-0">
                      {{'General.ConfirmationSubHeadline' | translate}}
                    </h3>
                    <div class="d-flex justify-content-center justify-content-xl-start text-white mt-4">
                        <div>
                          <div class="row m-0 pb-4 align-items-center">
                            <div class="col-auto fs-4">
                              <i class="far fa-clipboard-list"></i>
                            </div>
                            <div class="col">
                              {{'General.NoRiskInformation' | translate}}
                            </div>
                          </div>

                          <div class="row m-0 pb-3 align-items-center">
                            <div class="col-auto fs-4">
                              <i class="far fa-gauge-max"></i>
                            </div>
                            <div class="col">
                              {{'General.FastProcessing' | translate}}
                            </div>
                          </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>

              <div class="w-100 mt-auto fade-in-slow-300">
                <app-trustpilot-wide></app-trustpilot-wide>
              </div>

              <div class="pt-3 w-100 mb-3 mb-xl-0 pb-1">
                <app-footer
                  [color]="'white'"
                  [loading]="loaded()">
                </app-footer>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
